import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";

export default function NotFound() {
  return (
    <Layout>
      <section className="py-24">
        <div className="abc-container text-center max-w-xl mx-auto">
          <div className="font-display text-7xl font-extrabold text-[#1A1D21]">404</div>
          <h1 className="font-display text-2xl font-extrabold text-[#1A1D21] mt-3">Page not found</h1>
          <p className="text-slate-600 mt-2">The page you're looking for doesn't exist or has moved.</p>
          <Link to="/" className="abc-btn abc-btn-accent mt-6 inline-flex" data-testid="notfound-home">Back to Home</Link>
        </div>
      </section>
    </Layout>
  );
}
